import React, { createContext, useState, useContext } from 'react';

// Crear contexto para compartir el estado del formulario entre componentes
const FormContext = createContext();

export const useFormContext = () => useContext(FormContext);

export const FormProvider = ({ children }) => {
  // Estado para almacenar los datos del formulario
  const [formValues, setFormValues] = useState({
    ofertante: {
      nombre: "",
      apellidos: "",
      email: "",
      identificacion: "",
      movil: ""
    },
    contraparte: {
      nombre: "",
      apellidos: "",
      email: "",
      identificacion: "",
      movil: ""
    },
    representacionContraparte: {
      activa: false,
      nombre: "",
      apellidos: "",
      email: "",
      identificacion: "",
      movil: ""
    },
    referencia: "",
    objeto: "",
    cuantia: "",
    confidencialidad: true,
    plazoRespuesta: "",
    contenido: "",
    archivo: null,
    aceptaCondiciones: false
  });

  // Función para actualizar valores específicos
  const updateFormValue = (section, field, value) => {
    if (field) {
      // Actualizar un campo específico dentro de una sección
      setFormValues(prev => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value
        }
      }));
    } else {
      // Actualizar una sección completa
      setFormValues(prev => ({
        ...prev,
        [section]: value
      }));
    }
  };
  
  // Función para actualizar múltiples campos a la vez
  const updateFormData = (updates) => {
    setFormValues(prev => ({
      ...prev,
      ...updates
    }));
  };
  
  // Función para actualizar un paso completo
  const updateStep = (step, data) => {
    if (step === 1) {
      setFormValues(prev => ({
        ...prev,
        ofertante: data.ofertante || prev.ofertante,
        contraparte: data.contraparte || prev.contraparte,
        representacionContraparte: data.representacionContraparte || prev.representacionContraparte
      }));
    } else if (step === 2) {
      setFormValues(prev => ({
        ...prev,
        referencia: data.referencia !== undefined ? data.referencia : prev.referencia,
        objeto: data.objeto !== undefined ? data.objeto : prev.objeto,
        cuantia: data.cuantia !== undefined ? data.cuantia : prev.cuantia,
        confidencialidad: data.confidencialidad !== undefined ? data.confidencialidad : prev.confidencialidad,
        plazoRespuesta: data.plazoRespuesta !== undefined ? data.plazoRespuesta : prev.plazoRespuesta,
        contenido: data.contenido !== undefined ? data.contenido : prev.contenido,
        archivo: data.archivo !== undefined ? data.archivo : prev.archivo,
        aceptaCondiciones: data.aceptaCondiciones !== undefined ? data.aceptaCondiciones : prev.aceptaCondiciones
      }));
    }
  };
  
  // Función para resetear el formulario
  const resetForm = () => {
    setFormValues({
      ofertante: {
        nombre: "",
        apellidos: "",
        email: "",
        identificacion: "",
        movil: ""
      },
      contraparte: {
        nombre: "",
        apellidos: "",
        email: "",
        identificacion: "",
        movil: ""
      },
      representacionContraparte: {
        activa: false,
        nombre: "",
        apellidos: "",
        email: "",
        identificacion: "",
        movil: ""
      },
      referencia: "",
      objeto: "",
      cuantia: "",
      confidencialidad: true,
      plazoRespuesta: "",
      contenido: "",
      archivo: null,
      aceptaCondiciones: false
    });
  };

  return (
    <FormContext.Provider value={{ 
      formValues, 
      updateFormValue, 
      updateFormData,
      updateStep, 
      setFormValues,
      resetForm 
    }}>
      {children}
    </FormContext.Provider>
  );
};

export default FormContext; 